import React from 'react'

import {
  RESUME_LINE_GUIDE_COLORS,
  RESUME_LINE_GUIDE_HEADER_END_COLOR,
  RESUME_LINE_GUIDE_PAGE_BREAK_COLOR,
} from '../../utils/resumePreviewLineGuides'

export function ResumePreviewPageBreakEdge() {
  return (
    <div
      className="resume-preview-page-break-edge pointer-events-none absolute inset-x-0 bottom-0 z-30 flex items-end justify-end"
      style={{
        height: 5,
        backgroundColor: RESUME_LINE_GUIDE_PAGE_BREAK_COLOR,
        opacity: 1,
        boxShadow: '0 -1px 0 rgba(225,29,72,0.35), 0 0 8px rgba(225,29,72,0.25)',
      }}
      aria-hidden
      title="край страницы"
    >
      <span className="mb-0.5 mr-0.5 rounded-sm bg-rose-600 px-1 py-px text-[9px] font-semibold uppercase tracking-wide text-white">
        край страницы
      </span>
    </div>
  )
}

const LANDMARKS: Array<{ block: string; label: string; hint: string; color: string; sampleClass?: string }> = [
  {
    block: 'header-end',
    label: 'Низ шапки',
    hint: 'синяя пунктирная полоса на всю ширину',
    color: RESUME_LINE_GUIDE_HEADER_END_COLOR,
    sampleClass: 'resume-preview-line-guides-legend-sample--header-end',
  },
  {
    block: 'right',
    label: 'Правая колонка',
    hint: 'розовые линии + розовая полоска слева в колонке',
    color: RESUME_LINE_GUIDE_COLORS.right,
  },
  {
    block: 'page',
    label: 'Край страницы',
    hint: 'красная жирная полоса внизу листа',
    color: RESUME_LINE_GUIDE_PAGE_BREAK_COLOR,
    sampleClass: 'resume-preview-line-guides-legend-sample--page-edge',
  },
]

const DETAIL_LEGEND: Array<{ block: string; label: string; color: string }> = [
  { block: 'header', label: 'Строки шапки', color: RESUME_LINE_GUIDE_COLORS.header },
  { block: 'target', label: 'Target title', color: RESUME_LINE_GUIDE_COLORS.target },
  { block: 'summary', label: 'Summary', color: RESUME_LINE_GUIDE_COLORS.summary },
  { block: 'section', label: 'Секция', color: RESUME_LINE_GUIDE_COLORS.section },
  { block: 'role', label: 'Роль / компания', color: RESUME_LINE_GUIDE_COLORS.role },
  { block: 'bullet', label: 'Буллет', color: RESUME_LINE_GUIDE_COLORS.bullet },
  { block: 'skills', label: 'Skills', color: RESUME_LINE_GUIDE_COLORS.skills },
]

function LegendSwatch({
  color,
  sampleClass,
}: {
  color: string
  sampleClass?: string
}) {
  return (
    <span
      className={`inline-block h-1 w-6 shrink-0 rounded-sm ${sampleClass ?? ''}`}
      style={
        sampleClass
          ? undefined
          : {
              backgroundColor: color,
            }
      }
    />
  )
}

export function ResumePreviewLineGuidesLegend() {
  return (
    <div
      className="resume-preview-line-guides-legend mb-3 w-full max-w-[210mm] rounded-md border border-border-default bg-surface-elevated px-3 py-2 text-xs text-text-secondary shadow-sm"
      data-testid="resume-line-guides-legend"
    >
      <p className="mb-2 font-medium text-text-primary">
        Режим lineGuides=1 — три ориентира отделены цветом и толщиной
      </p>
      <ul className="mb-2 flex flex-col gap-1.5">
        {LANDMARKS.map((item) => (
          <li key={item.block} className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
            <LegendSwatch color={item.color} sampleClass={item.sampleClass} />
            <span className="font-medium text-text-primary">{item.label}</span>
            <span className="text-text-secondary">— {item.hint}</span>
          </li>
        ))}
      </ul>
      <p className="mb-1 text-[11px] text-text-secondary">Остальные блоки (тонкие линии):</p>
      <ul className="flex flex-wrap gap-x-3 gap-y-1">
        {DETAIL_LEGEND.map((item) => (
          <li key={item.block} className="flex items-center gap-1.5">
            <LegendSwatch color={item.color} />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function ResumePreviewColumnZoneLabel({ side }: { side: 'left' | 'right' }) {
  const isRight = side === 'right'
  return (
    <div
      className="pointer-events-none absolute left-0 top-0 z-40 flex max-w-full items-start"
      aria-hidden
    >
      <span
        className={`rounded-br-sm px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-white ${
          isRight ? 'bg-pink-600' : 'bg-slate-500'
        }`}
      >
        {isRight ? 'правая колонка' : 'левая колонка'}
      </span>
    </div>
  )
}
